export default __webpack_public_path__ + "static/media/content_share.987beac4.svg";